import { createAction, props } from '@ngrx/store';

export const signOuts = createAction(
  '[SignOut] Clear State'
);




